var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVimeo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.525183 5.33992C0.470985 5.40673 0.441406 5.49015 0.441406 5.57617C0.441406 5.6622 0.470985 5.74562 0.525183 5.81242L0.817683 6.20242C0.87591 6.27893 0.961299 6.33015 1.05621 6.34551C1.15112 6.36086 1.2483 6.33917 1.32768 6.28492C1.77768 5.98492 2.61768 5.53492 2.97018 5.91742C3.45018 6.48742 5.28768 13.3649 5.90268 14.6324C6.43518 15.7424 7.91268 17.2124 9.53268 16.1324C11.1527 15.0524 16.5002 10.4999 17.4827 5.08492C18.3902 -7.54595e-05 11.8427 0.682424 10.4177 4.73242C10.3953 4.79786 10.3914 4.86821 10.4064 4.93572C10.4215 5.00322 10.455 5.06524 10.5031 5.11492C10.5512 5.1646 10.6121 5.2 10.6791 5.21721C10.7461 5.23442 10.8166 5.23276 10.8827 5.21242C12.3827 4.73992 13.1327 6.22492 12.2327 7.88242C11.2502 9.74992 10.3052 11.0024 9.82518 11.0024C9.34518 11.0024 9.00018 9.74992 8.42268 7.53742C7.84518 5.32492 7.86018 1.16242 5.49018 1.62742C3.60768 1.99492 1.22268 4.54492 0.525183 5.33992Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVimeo);
export default __webpack_public_path__ + "static/media/vimeo.66ed6d4086525c8eb27caa257ae84038.svg";
export { ForwardRef as ReactComponent };